<template>
  <div id="remPutAway" v-loading="loading">
    <v-container :left="true" :title="title" :height="'0.6rem'" @esc="esc">
      <v-input
        :config="config"
        :models="models"
        :rules="rules"
        @complete="complete"
        @esc="esc"
        ref="models"
        slot="content"
      ></v-input>
      <v-foot :btn-config="btnConfig" @up="up" @dow="dow" slot="footer"></v-foot>
      <!-- <v-foot :btn-config="saveBtnConfig" @saveCon="saveCon" slot="footer"></v-foot> -->
    </v-container>
  </div>
</template>

<script>
import container from "../../../commons/Container"
import input from "../../../commons/Input"
import foot from "../../../commons/Footer"
import {
  queryTaskManagerUserDetailByRem,
  verifyRem,
  queryBusinessBatchNo,
  verifyQtyAndUom,
  move
} from "@/api/change/change";

export default {
  name: "remPutAway",
  data() {
    return {
      loading: false,
      title: this.$t('module.remPutAway'),
      config: [
        {label: this.$t('module.fromloc'), prop: "fromLoc", disabled: false},
        {label: this.$t('module.LPN'), prop: "fromId", disabled: false},
        {label: this.$t('module.SKU'), prop: "sku", disabled: false},
        {label: this.$t('module.storerKey'), prop: "storerKey", disabled: false},
        {label: this.$t('module.productDate'), prop: "productDate", disabled: false},
        {label: this.$t('module.supplierBatch'), prop: "lot", disabled: false},
        {label: this.$t('module.place'), prop: "place", disabled: false},
        {label: this.$t('module.qtyreceived'), prop: "qty", disabled: false},
        {label: this.$t('module.uom'), prop: "uom", type: "select", disabled: false, options: [{'description': 'CA', 'code': 'CA'}, {'description': 'BC', 'code': 'BC'}]},
        {label: this.$t('module.sellloc'), prop: "toLoc", disabled: false},
        {label: this.$t('module.confirmLoc'), prop: "toLocConfirm", disabled: false},
        {label: this.$t('common.confirm')+"LPN", prop: "toIdConfirm", disabled: false}
      ],
      models: {
        fromLoc: 'PICKTO',
        fromId: undefined,
        sku: undefined,
        storerKey: undefined,
        productDate: undefined,
        place: undefined,
        lot: undefined,
        qty: undefined,
        uom: undefined,
        toLoc: undefined,
        toLocConfirm: undefined,
        toIdConfirm: undefined
      },
/*      models: {
        fromLoc: 'PICKTO',
        fromId: 'R343434789',
        sku: '赤兔马运动鞋',
        storerKey: undefined,
        productDate: undefined,
        place: undefined,
        lot: undefined,
        qty: undefined,
        uom: undefined,
        toLoc: undefined,
        toLocConfirm: undefined,
        toIdConfirm: undefined
      },*/
      rules: {
        fromLoc: [
          {required: true, message: this.$inputEmptyMes('module.toloc'), trigger: " "}
        ],
        sku: [
          {required: true, message: this.$ScanPlease('module.sku'), trigger: " "},
        ],
        qty: [
          {required: true, message: this.$inputEmptyMes('module.qtyreceived'), trigger: " "},
        ],
        uom: [
          {required: true, message: this.$inputEmptyMes('module.uom'), trigger: " "},
        ],
        toLocConfirm: [
          {required: true, message: this.$inputEmptyMes('module.confirmLoc'), trigger: " "},
        ]
      },
      btnConfig: [
        {label: this.$t('module.uplot'), invalid: "up",authCode: 'RF01150101'},
        {label: this.$t('module.dowlot'), invalid: "dow",authCode: 'RF01150102'},
        {label: this.$t('module.saveCon1'), invalid: "saveCon",authCode: 'RF01150103'},
      ],
      saveBtnConfig: [
      ],
      isVerifySku: true,
      lotList: [],
      lotLength: 0,
      currentIndex: 0
    }
  },
  created() {
    this.queryTaskManagerUserDetailByRem();
  },
  watch: {
    models: {
      handler(newVal) {
        if (this.isVerifySku && this.models.fromLoc !== undefined && this.models.sku !== undefined) {
          this.verifyRem();
        }
      },
      deep: true
    }
  },
  methods: {
    move() {
      move(this.models).then((res) => {
        let data = res.data;
        if (res.status === 200 && data.returnCode === "200") {
          this.$message.success(this.$t('module.sku')+"：" + this.model.sku +this.$t('module.success6'));
          this.$router.go(-1);
        } else {
          return this.$message.error(data.returnMgr);
        }
      })
    },
    queryBusinessBatchNo() {
      queryBusinessBatchNo(this.models).then((res) => {
        let data = res.data;
        if (res.status === 200 && data.returnCode === "200") {
          this.models = {
            ...data.data
          };
        } else {
          return this.$message.error(data.returnMgr);
        }
      })
    },
    verifyRem() {
      verifyRem(this.models).then((res) => {

        let data = res.data;
        if (res.status === 200 && data.returnCode === "200") {
          this.music2()
          this.isVerifySku = !this.isVerifySku;
          this.queryBusinessBatchNo();
        } else {
          this.music()
          return this.$message.error(data.returnMgr);
        }
      });
    },
    queryTaskManagerUserDetailByRem() {

      queryTaskManagerUserDetailByRem().then((res) => {
        let data = res.data;
        if (res.status === 200 && data.returnCode === "200") {
          if (data.data === 0) {
            this.$message.error(this.$t('module.error40'));
            return this.$router.go(-1);
          } else {
            // 调用转移编号
            // this.getBusinessNumber();
          }
        } else {
          return this.$message.error(data.returnMgr);
        }
      });
    },
    esc() {
      this.$router.go(-1);
    },
    async complete(model, ref, callback) {
      this.loading = true;
      try {
        verifyQtyAndUom(model).then((res) => {

          let data = res.data;
          if (res.status === 200 && data.returnCode === "200") {
            this.music2()
            this.move();
          } else {
            this.music()
            this.$message.error(data.returnMgr);
          }
        });
      } catch (error) {
        this.$message.error(error)
      } finally {
        this.loading = false;
      }
    },
    up() {

      let lotLength = this.lotLength;
      let currentIndex = this.currentIndex;
      if (lotLength === 1) {
        this.$message.error(this.$t('module.error41'));
      } else if (lotLength > 0 && currentIndex !== 0) {
        this.currentIndex = currentIndex - 1;
        this.models.lot = this.lotList[this.currentIndex];
        // 验证成功子组件调用父组件函数 complete
      } else {
        this.$message.error(this.$t('module.error42'));
      }
    },
    dow() {

      let lotLength = this.lotLength;
      let currentIndex = this.currentIndex;
      if (lotLength === 1) {
        this.$message.error(this.$t('module.error41'));
      } else if (lotLength > 0 && currentIndex !== lotLength) {
        this.currentIndex = currentIndex + 1;
        this.models.lot = this.lotList[this.currentIndex];
      } else {
        this.$message.error(this.$t('module.error42'));
      }
    },
    saveCon() {
      // 验证参数
      this.$refs.models.submit(12, 2);
      // 验证成功子组件调用父组件函数 complete
    }
  },
  mounted() {
  },
  components: {
    "v-container": container,
    "v-input": input,
    "v-foot": foot
  }
}
</script>

<style scoped>

</style>
